import styled, { css } from 'styled-components';
import { MButtonType, MButtonSize } from './MButton.types';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const Wrapper = styled.button<{
  $buttonType: MButtonType;
  $size: MButtonSize;
}>`
  ${({ $buttonType, $size }) =>
    $buttonType === MButtonType.Tertiary
      ? css`
          &.m-link-tertiary-button,
          &.m-link-tertiary-button-external {
            display: inline-flex;
            border-bottom: 0;
            gap: ${spacers?.spacers?.[1] ?? '0.25rem'};
            align-items: center;
            justify-content: center;
            line-height: 2rem;
            margin-inline: 0;
            padding: 0;
            background-color: transparent;
            &::before,
            &::after {
              content: '';
              display: none;
            }
            &:hover,
            &:focus {
              border-bottom: 0;
            }
            &.disabled {
              pointer-events: none;
              color: ${baseVariables.color.neutral30};
              .icon {
                color: ${baseVariables.color.neutral30};
              }
            }
            &:not(.disabled) {
              &:hover,
              &:focus {
                .btn-label {
                  text-decoration: underline;
                }
              }
              .icon {
                color: var(--t-button-tertiary-color);
              }
            }
          }
        `
      : css`
          &[class*='m-button'] {
            padding-inline: ${$size === MButtonSize.L
              ? spacers?.spacers?.[4] ?? '1.5rem'
              : spacers?.spacers?.[3] ?? '1rem'};
            padding-block: 0;
            display: inline-flex;
            gap: ${spacers?.spacers?.[1] ?? '0.25rem'};
            align-items: center;
            justify-content: center;
            &.disabled {
              &:focus {
                outline: 0;
              }
              .icon {
                color: ${baseVariables.color.base20};
              }
            }
            &:not(.disabled) {
              .icon {
                color: ${$buttonType === MButtonType.Primary
                  ? 'var(--t-button-primary-fg-color)'
                  : 'var(--t-button-secondary-fg-color)'};
              }
              &:hover .icon {
                color: ${$buttonType === MButtonType.Primary
                  ? 'var(--t-button-primary-hover-fg-color, var(--t-button-primary-fg-color))'
                  : 'var(--t-button-secondary-hover-fg-color, var(--t-button-secondary-fg-color))'};
              }
            }
          }
          &.icon-leading {
            padding-inline-start: ${$size === MButtonSize.L ? 1.25 : 0.75}rem;
          }
          &.icon-trailing {
            padding-inline-end: ${$size === MButtonSize.L ? 1.25 : 0.75}rem;
          }
        `}
`;

export const Label = styled.span`
  line-height: inherit;
  display: inline-block;
  white-space: nowrap;
`;
